import script from "./main.vue?vue&type=script&lang=ts&setup=true"
export * from "./main.vue?vue&type=script&lang=ts&setup=true"

import "./main.vue?vue&type=style&index=0&id=2b44db56&lang=less&scoped=true"
import "./main.vue?vue&type=style&index=1&id=2b44db56&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b44db56"]])

export default __exports__